<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark">Lot missing orders</h1>
                    </div><!-- /.col -->
                    <div class="col-sm-6">
                        <img id="logoId" src="../../../public/images/logo.png" style="width:40px; height:40px; display:none;">
                    </div><!-- /.col -->
                </div><!-- /.row -->
            </div><!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="order_id">Order ID</label>
                                            <input type="text" id="order_id" v-model="search.order_id" class="form-control" />
                                        </div>
                                    </div>
                                    <div v-if="authUser.role_id != 7" class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="title">Destination Hub</label>
                                            <v-select name="hub_id"
                                                v-model="search.destination_hub_id"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options= hubList
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="title">Merchant</label>
                                            <v-select name="hub_id"
                                                v-model="search.merchant_id"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options= commonObj.merchantList
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="date">Start Date</label>
                                            <input type="date" id="date" v-model="search.start_date" class="form-control" />
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="date">End Date</label>
                                            <input type="date" id="date" v-model="search.end_date" class="form-control" />
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <button class="btn btn-info btn-sm" type="submit" @click.prevent="searchData" style="margin-top:28px;"><i class="fa fa-search"></i></button>
                                            <button class="btn btn-warning btn-sm ml-1" @click.prevent="reload" style="margin-top:28px;"><i class="fa fa-sync-alt"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <b-overlay :show="loader">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-striped table-sm">
                                            <thead>
                                                <tr>
                                                    <th>SL</th>
                                                    <th>Order ID</th>
                                                    <th>Merchant</th>
                                                    <th>Customer</th>
                                                    <th>Date</th>
                                                    <th>Price</th>
                                                    <th>Source to Destination</th>
                                                    <th>Status</th>
                                                    <th style="text-align:center;">Action</th>
                                                </tr>
                                            </thead>
                                            <tfoot>
                                                <tr>
                                                    <th>SL</th>
                                                    <th>Order ID</th>
                                                    <th>Merchant</th>
                                                    <th>Customer</th>
                                                    <th>Date</th>
                                                    <th>Price</th>
                                                    <th>Source to Destination</th>
                                                    <th>Status</th>
                                                    <th style="text-align:center;">Action</th>
                                                </tr>
                                            </tfoot>
                                            <tbody>
                                                <tr v-for="(item, index) in listData" :key="index">
                                                    <td>{{ index+1 }}</td>
                                                    <td>
                                                        {{ item.id }}
                                                        <i
                                                            class="fa fa-copy"
                                                            style="margin-left: 8px; cursor: pointer; color: #555;"
                                                            @click="copyToClipboard(item.id)"
                                                            title="Copy Order ID"
                                                        ></i>
                                                    </td>
                                                    <td @click="orderLog(item.logs)">{{ item.merchant ? item.merchant.business : '' }}</td>
                                                    <td>{{ item.name }}, {{ item.mobile }}</td>
                                                    <td>{{ item.date | dateformat }}</td>
                                                    <td>{{ item.price }}</td>
                                                    <td>{{ item.source ? item.source.name : '' }} to {{ item.destination ? item.destination.name : '' }}</td>
                                                    <td><span :class="'status-'+ item.status">{{ getStatus(item.status) }}</span></td>
                                                    <td style="text-align:center;">
                                                        ---                                                      
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>  
                                    </div>
                                    <div class="mt-3">
                                        <b-pagination
                                            v-model="pagination.currentPage"
                                            :per-page="pagination.perPage"
                                            :total-rows="pagination.totalRows"
                                            @input="searchData"
                                        />
                                    </div>
                                </b-overlay>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>
        <!-- Order Log Modal -->
        <div
            v-if="orderLogModal"
            class="modal fade show"
            style="display: block"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
            >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header bg-info text-white">
                    <h5 class="modal-title text-center w-100">Order Log</h5>
                    <button type="button" class="close" aria-label="Close" @click="cancelModal">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <table class="table table-bordered table-sm">
                    <tr>
                        <th style="width: 30%">Action By</th>
                        <th style="width: 45%">Action</th>
                        <th style="width: 25%">Date & Time</th>
                    </tr>
                    <tr v-for="(log, index) in logs" :key="index">
                        <td>{{ log.operation_by }}</td>
                        <td>{{ log.operation }}</td>
                        <td>{{ log.created_at | dateformat }} at {{ log.created_at | timeformat }}</td>
                    </tr>
                    </table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" @click="cancelModal">
                    Cancel
                    </button>
                </div>
                </div>
            </div>
        </div>

        <div v-if="statusModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <b-overlay :show="loader">
                    <form v-on:keyup.enter="updatePickup">
                        <b-overlay :show="loader">
                            <div class="modal-content">
                                <div class="modal-header bg-info text-white">
                                    <h5 class="modal-title text-center w-100">LOT status update</h5>
                                    <button type="button" class="close" aria-label="Close" @click="cancelModal">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                                        <form @submit.prevent="handleSubmit(updateLot)">
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <ValidationProvider name="Total Order" vid="total_order" v-slot="{errors}" rules="required">
                                                        <div class="form-group">
                                                            <label for="total_order">Total Order</label>
                                                            <input type="text" id="total_order" v-model="form_edit.total_order" readonly="1" class="form-control" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');">
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div> 
                                                    </ValidationProvider>                         
                                                </div> 
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <ValidationProvider name="Hub Received" vid="consignment_id" v-slot="{errors}" rules="required">
                                                        <div class="form-group">
                                                            <label for="consignment_id">Consignment ID<span class="text-danger" title="Required">*</span></label>
                                                            <input type="text" id="consignment_id" v-model="form_edit.consignment_id" class="form-control" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');">
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div> 
                                                    </ValidationProvider>                         
                                                </div> 
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <ValidationProvider name="Current Status" vid="consignment_id" v-slot="{errors}" rules="required">
                                                        <div class="form-group">
                                                            <label for="current_status">Current Status</label>
                                                            <input type="text" id="current_status" :value="getStatus(form_edit.status)" readonly="1" class="form-control">
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div> 
                                                    </ValidationProvider>                         
                                                </div> 
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                    <ValidationProvider name="Time" vid="time" v-slot="{errors}" rules="required">
                                                        <div class="form-group">
                                                            <label for="time">Status <span class="text-danger" title="Required">*</span></label>
                                                            <v-select name="time"
                                                                style=""
                                                                v-model="form_edit.new_status"
                                                                label="text"
                                                                :reduce="item => item.id"
                                                                :options= lotEditStatusList
                                                                :placeholder="$t('globalTrans.select')"
                                                            />
                                                            <span class="text-danger">{{ errors[0] }}</span>
                                                        </div>  
                                                    </ValidationProvider>                      
                                                </div>
                                            </div>
                                        </form>
                                    </ValidationObserver>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-info" @click.prevent="updateLot">{{ $t('globalTrans.submit') }}</button>
                                    <button type="button" class="btn btn-danger" @click="cancelModal">{{ $t('globalTrans.cancel') }}</button>
                                </div>
                            </div>
                        </b-overlay>
                    </form>
                </b-overlay>
            </div>
        </div>
    </div>
</template>
<script>
    import config from '@/config'
    import moment from 'moment'
    import 'jspdf-autotable';
    import ExportPdf from './DetailsPdf'
    import Label from './Label.js'
    export default {
        name:'MissingOrder',
        data(){
            return {   
                loader: false,  
                orderLogModal: false, 
                statusModal: false,  
                logs: [],        
                search: {
                    order_id: '',
                    merchant_id: '',
                    destination_hub_id: '',
                    start_date : moment().subtract(30,'d').format('YYYY-MM-DD'),
                    end_date   : moment().format('YYYY-MM-DD')
                },
                key:'',
                form_edit: '',
                lotEditStatusList: [],
                errors:[],
                pagination: {
                    currentPage: 1,
                    totalRows: 0,
                    perPage: this.$store.state.commonObj.perPage,
                    slOffset: 1
                }
            }
        },
        created(){
            this.loadData()
        },
        watch: {
            stateReload : function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.loadData()
                }
            }
        },
        computed : {
            stateReload () {
                return this.$store.state.stateReload
            },
            listData () {
                return this.$store.state.list
            },
            commonObj () {
                return this.$store.state.commonObj
            },
            hubList: function () {
                return this.$store.state.commonObj.hubList
            },
            authUser () {
                return this.$store.state.authUser
            },
            lotStatusList () {
                return this.$store.state.lotStatusList
            }
        },
        methods:{
            copyToClipboard(text) {
                navigator.clipboard.writeText(text)
            },
            printLabel() {
                const base64Logo = this.getBase64Logo(document.getElementById('logoId'))
                Label.exportLabelDetails(base64Logo, this.printorders)
            },
            reload () {
                this.search = Object.assign({}, {
                    merchant_id: '',
                    hub_id: '',
                    amount: '',
                    start_date : moment().subtract(10,'d').format('YYYY-MM-DD'),
                    end_date   : moment().format('YYYY-MM-DD')
                })
            },
            showStatusUpdate(itemDetails) {
                this.getLotEditStatusList(itemDetails.status)
                this.form_edit = Object.assign(itemDetails, { new_status: '' })
                this.statusModal = true
            },
            searchData () {
                this.loadData()
            },
            async loadData(){    
                this.loader = true 
                const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })       
                const response = await config.getData('/lot/missing-order', params)
                this.loader = false
                if (response.success){
                    this.$store.dispatch('setList', response.data.data)
                    this.paginationData(response.data)
                } else {
                    this.$store.dispatch('setList', [])
                } 
            },
            paginationData (data) {
                this.pagination.currentPage = data.current_page
                this.pagination.totalRows = data.total
                this.pagination.perPage = data.per_page
                this.pagination.slOffset = this.pagination.perPage * this.pagination.currentPage - this.pagination.perPage + 1
            },
            lotDetails (id) {
                const url = this.$router.resolve({ name: 'lot.details', query: { id: id} }).href;
                window.open(url, '_blank');
            },
            orderLog(logs) {
                this.orderLogModal = true;
                this.logs = logs;
            },
            cancelModal(){
                this.statusModal = this.orderLogModal = false;
                document.body.classList.remove("modal-open");
            },
            getStatus (status) {
                const getStatus = this.$store.state.statusList.find(el => el.id == status)
                return getStatus.text ?? '';
            },
            async downloadPdf(itemId){
                this.loader = true
                const response = await config.getData(`/return/details/${itemId}`)
                this.loader = false
                if (response.success) {
                    this.pdfDownload(response.data, response.merchant, response.rider)   
                } else {                
                    this.$toast.error('Sorry, something went wrong')  
                }
            },
            pdfDownload(datas, merchant, rider) {
                // this.loader = true
                const base64Logo = this.getBase64Logo(document.getElementById('logoId'))
                ExportPdf.returnPdfDetails(base64Logo, datas, merchant, rider)
                // this.loader = false
            },
            getBase64Logo (logo) {
                var canvas = document.createElement('canvas')
                canvas.width = logo.width
                canvas.height = logo.height
                var ctx = canvas.getContext('2d')
                ctx.drawImage(logo, 0, 0)
                var dataURL = canvas.toDataURL('image/png')
                return dataURL.replace(/^data:image\/(png|jpg);base64,/, '')
            },
            async returnReceive (id) {
                this.loader = true
                this.$store.dispatch('stateReload', true)
                const response = await config.getData(`/return/merchant-receive/${id}`)                
                this.loader = false
                if (response.success) {  
                    this.$toast.success({
                        title: 'Success',
                        message: response.message,
                        color: '#218838'
                    })
                } else {
                    this.$toast.error({
                        title: 'Error',
                        message: response.message,
                        color: '#dc3545'
                    })
                }
                this.$store.dispatch('stateReload', false)  
            }
        }
    }
</script>
